export default __webpack_public_path__ + "static/media/madara.5b3e1b3f.png";